import type {CharacterState, DeathSaves} from './character-state';

export const DEATH_SAVES_LIMIT = 3;

const SUCCESS_THRESHOLD = 10;

export type DeathSaveOutcome = 'success' | 'failure' | 'doubleFailure' | 'revive';

export function deathSaveOutcome(dieValue: number, total: number): DeathSaveOutcome {
	if (dieValue === 20) return 'revive';
	if (dieValue === 1) return 'doubleFailure';
	return total >= SUCCESS_THRESHOLD ? 'success' : 'failure';
}

export function applyDeathSave(saves: DeathSaves, outcome: Exclude<DeathSaveOutcome, 'revive'>): DeathSaves {
	if (outcome === 'success') return {...saves, successes: Math.min(DEATH_SAVES_LIMIT, saves.successes + 1)};
	const failures = outcome === 'doubleFailure' ? 2 : 1;
	return {...saves, failures: Math.min(DEATH_SAVES_LIMIT, saves.failures + failures)};
}

/** персонаж получил ПЗ (потраченных стало меньше): испытания против смерти сбрасываются */
export function withDeathSavesReset(previous: CharacterState, next: CharacterState): CharacterState {
	const isHealed = next.hitPoints.spent < previous.hitPoints.spent;
	const hasMarks = next.deathSaves.successes > 0 || next.deathSaves.failures > 0;
	return isHealed && hasMarks ? {...next, deathSaves: {successes: 0, failures: 0}} : next;
}
